"use client";

import { OutboundLink } from "@/features/outbound-link/outbound-link";
import { useScrollThreshold } from "@/features/scrollspy/use-scroll-threshold";
import { BiEvent } from "@/lib/bi/bi.enum";
import { cn } from "@/lib/utils";

import { usePrimeDayCountdown } from "../../hooks/use-prime-day-countdown";
import { CountdownDigits } from "../countdown-digits";

type Props = {
  className?: string;
  primeDayUrl: string;
};

export function BannerBottom({ className, primeDayUrl }: Props) {
  const { hours, minutes, seconds } = usePrimeDayCountdown();
  const show = useScrollThreshold(100);

  return (
    <OutboundLink
      url={primeDayUrl}
      storeName="Amazon"
      bi={{
        eventType: BiEvent.BannerOutbound,
        provider: "amazon",
        location: "prime-day-banner",
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "min-h-13 max-h-16 h-[8.5vh] overflow-hidden",
        "flex items-center justify-center",
        "bg-[#e6f4ff] border-t-2 border-[#fda337] shadow-[0px_-4px_8px_0px_rgba(199,199,199,0.25)]",
        "text-[#216eb4] sub2 leading-6",
        "lg:hidden sticky bottom-0 translate-y-[200%] transition-transform duration-300 ease-in-out",
        show && "translate-y-px",
        className,
      )}
    >
      <div className="flex gap-x-2 items-baseline sm:justify-between sm:w-full sm:px-6">
        <span className="flex gap-x-2">
          <span>
            <span>Prime Day</span>
          </span>
          <span className="inline-flex items-center gap-0.5 text-[16px]">
            <CountdownDigits
              value={hours}
              label="Hrs"
            />
            <CountdownDigits
              value={minutes}
              label="Min"
            />
            <CountdownDigits
              value={seconds}
              label="Sec"
            />
          </span>
        </span>
        <span className="rounded-[8px] bg-[#4aa409] text-grayscale-white px-2 py-1 body2 self-start ms-2 leading-5">
          Check deals
        </span>
      </div>
    </OutboundLink>
  );
}
